var currentCheckoutCallback = null;
export var setCheckoutCallback = function setCheckoutCallback(callback) {
  currentCheckoutCallback = callback;
};
export var clearCheckoutCallback = function clearCheckoutCallback() {
  currentCheckoutCallback = null;
};
export var paddleEventCallback = function paddleEventCallback(eventData) {
  if (eventData.name === 'checkout.completed') {
    var _window$Paddle;
    var callback = currentCheckoutCallback;
    clearCheckoutCallback();
    if ((_window$Paddle = window.Paddle) !== null && _window$Paddle !== void 0 && _window$Paddle.Checkout) {
      window.Paddle.Checkout.close();
    }
    if (callback) {
      callback(eventData.data);
    }
  }
  if (eventData.name === 'checkout.closed') {
    if (currentCheckoutCallback) {
      currentCheckoutCallback(false);
      clearCheckoutCallback();
    }
  }
};